'use strict';

exports.__esModule = true;
exports.ApiRest = undefined;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _authHelper = require('../helpers/authHelper');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ApiRest = exports.ApiRest = {
  get: get,
  post: post,
  guardarDatoLocal: guardarDatoLocal,
  borrarDatoLocal: borrarDatoLocal,
  obtenerDatoLocal: obtenerDatoLocal,
  clearDatoLocal: clearDatoLocal
};

_axios2.default.interceptors.response.use(function (response) {
  //console.log('interceptor response',response);
  return response;
}, function (error) {
  //console.log('interceptor error 2',error);
  return Promise.reject(responseValidate(error));
});

function get(url) {
  var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _axios2.default.get(url, {
    headers: (0, _authHelper.authHeader)(header),
    //withCredentials: true,
    validateStatus: function validateStatus(status) {
      return status < 500; // Reject only if the status code is greater than or equal to 500
    }
  }).then(handleResponse).then(function (resultado) {
    return resultado;
  });
}

function post(url, data) {
  var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _axios2.default.post(url, data, {
    headers: (0, _authHelper.authHeader)(header) //withCredentials: true

  }).then(handleResponse).then(function (resultado) {
    return resultado;
  });
}

function guardarDatoLocal(nombre, dato) {
  localStorage.setItem(nombre, dato);
}

function borrarDatoLocal(nombre) {
  localStorage.removeItem(nombre);
}

function obtenerDatoLocal(nombre) {
  return localStorage.getItem(nombre);
}

function clearDatoLocal() {
  localStorage.clear();
}

function responseValidate(error) {
  if (!error.response) {
    switch (error) {
      case 'Unauthorized':
        return 'Usuario o claves incorrectos';

      default:
        return "Sin conexión por favor intente en unos minutos";
    }
  }

  if (error.response.data.status_code === 401) {
    return "Su sesión ha terminado";
  } else if (error.response.data.status_code === 406) {
    return error.response.headers['mensaje-autenticacion'];
  }

  if (error.response.data) {
    return error.response.data;
  }

  if (error.response) {
    switch (error.response.status) {
      case 401:
        return 'Usuario o claves incorrectos';

      default:
        return "Sin conexión por favor intente en unos minutos";
    }
  }
}

function handleResponse(response) {
  /*console.log(response.data);
  console.log(response.status);
  console.log(response.statusText);
  console.log(response.headers);
  console.log(response.config);*/
  var data = response.data;

  if (response.status !== 200) {
    var error = data && data.message || response.statusText;

    switch (response.status) {
      case 404:
        return 'vacio';

      case 401:
        guardarDatoLocal('sinacceso', 1);
        borrarDatoLocal('tokenSeps');
        return Promise.reject(error);

      default:
        return Promise.reject(error);
    }
  }

  return data;
}